// strings.js

const strings = {
    STRIPE_DEV_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/test_9AQaFH28R5pvaGI6p2", // clip embeddings
    STRIPE_PROD_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/3cs00TfnU8Rwffi4gT", // clip embeddings

    STRIPE_SUBSCRIPTION_MANAGEMENT_URL: "https://billing.stripe.com/p/login/28ocP200L31J9gs7ss",
    SUBSCRIPTION_STATUS_API_URL: "https://funquiz.app/modular2/subscription-status",
    
    GENERIC_PAGE_TITLE: "CLIP Embeddings AI 🎨",
    HOME_PAGE_TITLE: "Home - CLIP Embeddings AI 🎨",
    DASHBOARD_PAGE_TITLE: "Home - CLIP Embeddings AI 🎨",
    WELCOME_MESSAGE_H1_TITLE: "Welcome to CLIP Embeddings AI 🎨",
    FX_DESCRIPTION_MESSAGE: "This f(x) can be used to generate CLIP embeddings, enter a prompt and then press the 'Submit Input' button below to get your result!",
    
    MAIN_API_NAME: "clip_embeddings_ai_1",
    MAIN_API_URL: "https://funquiz.app/modular2/clip-embeddings-ai-1",

    PROD_CLERK_PUB_KEY: "pk_live_Y2xlcmsueW9sbGVnLmNvbSQ",
    DEV_CLERK_PUB_KEY: "pk_test_aGFybWxlc3MtYmVlLTY5LmNsZXJrLmFjY291bnRzLmRldiQ",

    // ... add more strings as needed
};



export default strings;